import { STATIC_ASSETS_CLOUDFRONT_URL } from "app/constants"
import { City } from "./regional-map.types"

export const CITIES: City[] = [
  {
    id: "national",
    title: "national_explorer",
    shortTitle: "NE",
    centerpoint: `-95.712891,37.09024`,
    geocoderPostfix: "usa",
    initialExtent: [-179.147, 18.911, -66.932, 71.357],
  },
  {
    id: "richmond",
    title: "Richmond, VA",
    shortTitle: "Richmond",
    centerpoint: `37.542981,-77.43043`,
    geocoderPostfix: "richmond va",
    initialExtent: [-77.802689, 37.324288, -77.112602, 37.764576],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/richmondva_sean_pavone_shutterstock_crop.jpg`,
    releaseDate: "Fall 2022",
    funder: "TAZO",
    funderLink: "https://www.tazo.com",
    supplementaryData: "ambient air temperature, parks and property ownership",
    PrimaryPartner: "City of Richmond",
    PrimaryPartnerLink: "https://www.rva.gov/",
    partnerList:
      "Virginia Community Voice | Richmond Tree Stewards | Seeds of Change Organization | Groundwork RVA | Science Museum of VA | Chesapeake Bay Foundation | JRPS Invasive Species Task Force | Reedy Creek Environmental | Virginia Department of Forestry | Capital Trees | Reforest Richmond | Sierra Club | Virginia Chapter | James River Association",
  },
  {
    id: "boston",
    title: "Boston, MA",
    shortTitle: "Boston",
    centerpoint: `42.361145,-71.057083`,
    geocoderPostfix: "boston ma",
    initialExtent: [-71.669312, 42.101279, -70.361252, 42.606169],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/boston_hero_adobestock.jpg`,
    releaseDate: "Winter 2022-2023",
    funder: "Anonymous",
    supplementaryData:
      "flood risk, MA environmental justice populations and open space designations",
    PrimaryPartner: "Speak for the Trees",
    PrimaryPartnerLink: "https://treeboston.org/",
    partnerList:
      "City of Boston Parks and Recreation | Tree Eastie | Mass Audubon | Livable Streets Alliance | USDA Forest Service | Mattapan Food and Fitness Coalition | Greater Mattapan Neighborhood Council | Edgewater Neighborhood Association | Codman Square Neighborhood Development Corporation | Arborway Coalition | Emerald Necklace Conservancy | Hyde Park Presbyterian Church",
  },
  {
    id: "dc",
    title: "DC region",
    shortTitle: "DC",
    centerpoint: `-77.039566,38.892636`,
    geocoderPostfix: "washington dc",
    initialExtent: [-78.160858, 38.41809, -75.918274, 39.364032],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/dc_hero_crop_adobestock.jpg`,
    releaseDate: "Spring 2023",
    funder: "National Fish and Wildlife Foundation",
    funderLink: "https://www.nfwf.org/",
    supplementaryData: "flood risk and parcel-level tree canopy loss and gain",
    PrimaryPartner: "Metropolitan Washington Council of Governments",
    PrimaryPartnerLink: "https://www.mwcog.org/",
    partnerList:
      "DOEE | Casey Trees | District Department of Transportation | Arlington County | Fairfax County | Anacostia Partnership | DC Urban Forestry Division | Montgomery Parks | Prince George's County | Maryland - National Capital Park and Planning | State of Maryland | USFS Mid-Atlantic Urban and Community Forestry | Defensores de la Cuenca | Nature Forward | EcoAction Arlington | VA Tech",
  },
  {
    id: "ruston",
    title: "Lincoln Parish, LA",
    shortTitle: "Lincoln Parish",
    centerpoint: `-92.637, 32.525`,
    geocoderPostfix: "lincoln parish la",
    initialExtent: [-92.716879, 32.495979, -92.572103, 32.577506],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/ruston_hero.jpg`,
    releaseDate: "Spring 2023",
    funder: "Weyerhaeuser",
    funderLink: "https://www.weyerhaeuser.com/",
    supplementaryData: "flood risk and commercial land use",
    PrimaryPartner: "TIGUAR Urban Forestry Consulting",
    PrimaryPartnerLink: "https://www.linkedin.com/in/dr-darrell-k-street-45286125b",
    partnerList:
      "City of Ruston | Residents of Lincoln Parish | Hope and Healing Hands | LA Tech University | Grambling State University | Family & Everyday Life",
  },
  {
    id: "rhode_island",
    title: "Rhode Island",
    shortTitle: "Rhode Island",
    centerpoint: `-71.5, 41.7`,
    geocoderPostfix: "rhode island",
    initialExtent: [-71.833217, 41.34627, -71.10996, 42.030374],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/ri_hero_crop_adobestock.jpeg`,
    releaseDate: "2020",
    funder: "Doris Duke Foundation",
    funderLink: "https://www.dorisduke.org/",
    supplementaryData: "ambient air temperature, RI Health Equity Zones and flood risk",
    PrimaryPartnerLink: "https://dem.ri.gov/",
    PrimaryPartner: "RI Department of Environmental Management",
    partnerList:
      "RI Tree Council | The Nature Conservancy RI | City of Providence Forestry Division | City of Newport Trees | Parks and Open Space | Newport Tree Conservancy | RI Infrastructure Bank | RI Department of Health | Groundwork RI | Providence Neighborhood Planting Program",
  },
  {
    id: "indianapolis",
    title: "Indianapolis & Marion County, IN",
    shortTitle: "Marion County",
    centerpoint: `-86.158068,39.768403`,
    geocoderPostfix: "indianapolis in",
    initialExtent: [-87.193453, 39.285229, -85.008547, 40.180783],
    treesTilesetId: "tesa-app.indianapolis-trees-20240418",
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/Indy-Connie-Szabo-Schmucker_2000w_crop.jpg`,
    releaseDate: "October 18, 2023",
    funder: "Salesforce",
    funderLink: "https://www.salesforce.com/company/sustainability/",
    supplementaryData: "parks access and current land use",
    PrimaryPartnerLink: "https://www.kibi.org/",
    PrimaryPartner: "Keep Indianapolis Beautiful",
    partnerList:
      "Hoosier Environmental Council | Davey Tree Services | Sav-A-Tree | Community Alliance of the Far East Side (CAFE) | City of Indianapolis Dept of Public Works | Indianapolis Metropolitan Planning Organizations | Health by Design | Indiana DNR | Tree Centric Solutions | Davey Resource Group | Groundwork Indy | Indiana Association of Soil and Water Conservation Districts",
  },
  {
    id: "detroit",
    title: "Detroit, MI",
    shortTitle: "Detroit",
    centerpoint: `-83.045753,42.331429`,
    geocoderPostfix: "detroit mi",
    initialExtent: [-85.166198, 41.455383, -80.908996, 43.177438],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/Detroit_hero_2000w_crop.jpg`,
    releaseDate: "December 2023",
    funder: "The Fred A. and Barbara M. Erb Family Foundation",
    funderLink: "https://www.erbff.org/",
    supplementaryData: "schools and air quality",
    PrimaryPartner: "Detroit Tree Equity Partnership",
    partnerList:
      "City of Detroit | Detroit Future City | The Greening of Detroit | Keep Growing Detroit | Michigan DNR | Rescue MI Nature Now! | Asthma & Allergy Foundation of America – Michigan Chapter | Detroit Zoological Society | Elliot Attisha, DO, FAAP | Southwest Detroit Environmental Vision",
  },
  {
    id: "maricopa",
    title: "Maricopa County, AZ",
    shortTitle: "Maricopa County",
    centerpoint: `-112.074037,33.448376`,
    geocoderPostfix: "",
    initialExtent: [-114.204375, 32.450301, -109.947172, 34.394075],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/phoenix_hero_2000w.jpg`,
    releaseDate: "Fall 2023",
    funder: "Bank of America",
    funderLink: "https://about.bankofamerica.com/en/making-an-impact",
    supplementaryData: "mean radiant temperature and cooling centers",
    PrimaryPartnerLink: "https://unlimitedpotentialaz.org/",
    PrimaryPartner: "Unlimited Potential",
    partnerList:
      "Arizona Sustainability Alliance | CHISPA AZ | City of Phoenix | City of Tempe | Maricopa County Public Health | The Nature Conservancy | Tiger Mountain Foundation | Trees Matter",
  },
  {
    id: "austin",
    title: "Austin, TX",
    shortTitle: "Austin",
    centerpoint: `-97.743057,30.267153`,
    geocoderPostfix: "",
    initialExtent: [-98.337425, 30.022468, -97.120689, 30.544259],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/austin_hero_2000w_crop.jpg`,
    releaseDate: "February 2024",
    funder: "Salesforce",
    funderLink: "https://www.salesforce.com/company/sustainability/",
    supplementaryData:
      "the tree planting investment index from the City of Austin Community Tree Priority Map and existing community gardens",
    PrimaryPartnerLink: "https://fruitfulcommons.org/",
    PrimaryPartner: "Fruitful Commons",
    partnerList:
      "City of Austin, Urban Forestry | City of Austin, Office of Resilience | City of Austin, Parks and Recreation | TreeFolks | University of Texas at Austin, RGK Center",
  },
  {
    id: "franklin",
    title: "Columbus & Franklin County, OH",
    shortTitle: "Franklin County, OH",
    centerpoint: `-82.998475,39.961799`,
    geocoderPostfix: "",
    initialExtent: [-83.306092, 39.828385, -82.690858, 40.094954],
    treesTilesetId: "tesa-app.franklin-trees-20240423",
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/columbus_hero_2000w_crop.jpg`,
    releaseDate: "January 2024",
    funder: "Google.org",
    funderLink: "https://www.google.org/",
    supplementaryData: "canopy loss and gain and existing land use",
    PrimaryPartnerLink: "https://www.greencbus.org/",
    PrimaryPartner: "Green Columbus",
    partnerList:
      "B.R.E.A.D. Columbus | Byrd Polar & Climate Research Center | Church of Christ (Linden) |Columbus & Franklin County Metro Parks | Columbus Citizens' Climate Lobby | Columbus Recreation & Parks Dept Forestry Division | Darby Creek Association | Franklin County Public Health | Franklin Park Conservatory | Franklin Soil & Water Conservation District | Franklinton Farms | Friends of Alum Creek and Tributaries | Friends of the Lower Olentangy Watershed | Grange Insurance Audubon Center | GreenSpot | Growing & Growth Collective | Human Service Chamber | IMPACT Community Action | Jewish Family Services | Keep Columbus Beautiful | Mid-Ohio Regional Planning Commission (MORPC) | Ohio Dept Natural Resources | Ohio Environmental Council | The Columbus Foundation | Urban Tree Project | USDA Forest Service",
  },
  {
    id: "dallas",
    title: "Dallas, TX",
    shortTitle: "Dallas",
    centerpoint: `-96.796667,32.776665`,
    geocoderPostfix: "",
    initialExtent: [-98.964159, 31.504433, -94.042284, 33.84611],
    treesTilesetId: "tesa-app.dallas-trees-20240424",
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/dallashero_af_crop.jpg`,
    releaseDate: "December 7, 2023",
    funder: "Salesforce",
    funderLink: "https://www.salesforce.com/company/sustainability/",
    supplementaryData: "Social Vulnerability Index (SVI) & parks",
    PrimaryPartnerLink: "https://texastrees.org/",
    PrimaryPartner: "Texas Tree Foundation",
    partnerList:
      "Collective Activism | Dallas Youth Sports | Black Heart Association | Keep America Beautiful | Texas A&M Forest Service",
  },
  {
    id: "toronto",
    title: "Toronto, ON",
    shortTitle: "Toronto",
    centerpoint: `-79.3832,43.6532`,
    geocoderPostfix: "",
    initialExtent: [-82.159425, 42.701424, -77.278749, 44.696786],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/Toronto_Hero_Crop2000w.jpg`,
    treesTilesetId: "tesa-app.toronto-trees-20240424",
    releaseDate: "February 2024",
    // funder: "American Express",
    // funderLink: "https://www.americanexpress.com/en-us/company/corporate-sustainability/",
    supplementaryData: "neighbourhoods & watersheds",
    PrimaryPartnerLink:
      "https://www.toronto.ca/services-payments/water-environment/trees/tree-planting/?accordion=tree-equity",
    PrimaryPartner: "City of Toronto",
    partnerList:
      "Local Enhancement and Appreciation of Forests (LEAF) | Black Outdoors | Cliffcrest Butterflyway | Corktown Residents and Business Association | East Scarborough Storefront - MakeWay Charitable Society | Grounded Solutions Services Ltd. | Guildwood Village Community Association | Institute of Forestry and Conservation, Daniels Faculty, University of Toronto | Long Branch Neighbourhood Association | Toronto Community Housing (TCHC) | Toronto Metropolitan University | Toronto Public Health | Trees for Life | Urban Forest Innovations Inc.",
    locale: "en-CA",
    pdfLinks: {
      // brackets so the linter ignores this string
      ["Methods"]: `${STATIC_ASSETS_CLOUDFRONT_URL}/Toronto_TreeEquityScore_Methodology_AmericanForests_04-2024.pdf`,
      "Data Glossary": `${STATIC_ASSETS_CLOUDFRONT_URL}/Toronto_TreeEquityScore_DataGlossary_AmericanForests_04-2024.pdf`,
    },
  },
  {
    id: "washington",
    title: "Washington State",
    shortTitle: "Washington State",
    centerpoint: `-117.429199,47.751076`,
    geocoderPostfix: "",
    initialExtent: [-124.775391, 45.546883, -116.916077, 49.002452],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/washington_hero_2000.jpg`,
    photoCredit: "David Moskowitz/Washington State Department of Natural Resources",
    treesTilesetId: "",
    releaseDate: "February 2025",
    funder: "WA DNR",
    supplementaryData: "public lands & watersheds",
    PrimaryPartnerLink: "https://www.dnr.wa.gov/urbanforestry",
    PrimaryPartner: "WA DNR",
    pdfLinks: {
      "Data Glossary": `${STATIC_ASSETS_CLOUDFRONT_URL}/TESA_Washington_Data_FAQsGlossary_Jul2025.pdf`,
    },
    resourcesLinks: {
      "Report Invasives Sightings": "https://invasivespecies.wa.gov/report-a-sighting/",
      "Identify Ash Borers": "https://invasivespecies.wa.gov/priorityspecies/emerald-ash-borer/",
      "Identify Longhorned Beetles":
        "https://invasivespecies.wa.gov/priorityspecies/citrus-asian-and-red-necked-longhorned-beetles/",
      "Identify Spongy Moths": "https://invasivespecies.wa.gov/priorityspecies/lymantriids/",
      "Identify Oak Borers": "https://treehealth.wsu.edu/mob/",
      "WA Urban Forest Pest Readiness Playbook":
        "https://invasivespecies.wa.gov/wp-content/uploads/2020/01/UrbanForestPestReadinessPlaybook.pdf",
      "Resilience and Forest Health - Vibrant Cities Lab":
        "https://www.vibrantcitieslab.com/urban-forestry-roadmap/resilience-and-forest-health/",
    },
  },
  {
    id: "houston",
    title: "Houston, TX",
    shortTitle: "Houston",
    centerpoint: `-95.3698,29.7604`,
    geocoderPostfix: "",
    initialExtent: [-96.833217, 29.504433, -93.942284, 30.84611],
    landingPageBackground: `${STATIC_ASSETS_CLOUDFRONT_URL}/houston_hero_2000w.jpg`,
    releaseDate: "December 2024",
    funder: "Google.org",
    funderLink: "https://www.google.org/",
    PrimaryPartner: "Trees for Houston",
    PrimaryPartnerLink: "https://www.treesforhouston.org/",
    partnerList:
      "Texas A&M Forest Service | Port of Houston | Environment Defense Fund | Houston Independent School District | City of Houston | Environmental Community Advocates of Galena Park",
    supplementaryData: "flooding, bus stops, and school districts",
  },
]

export const HIDE_TREES_LAYER_FROM_LOCATION = ["washington"]

export const CITIES_BASE_LAYERS_TILES: Record<string, string> = {
  austin: "tree_planting_service_area",
}

export const BASE_LAYER_ID = "base_layer"

export type BaseLayerConfig = {
  id: string
  title: string
  opacity: number
  explanation: string
  dataSource: string
}

export const BASE_LAYER_OPACITY = 0.3

export const BASE_LAYERS: Record<string, BaseLayerConfig[]> = {
  austin: [
    {
      id: BASE_LAYER_ID,
      title: "Austin Energy Service Area",
      opacity: BASE_LAYER_OPACITY,
      explanation:
        "This layer depicts the extent of Austin Energy's electric service boundary, which may be used—among other criteria—to help determine eligibility for free tree distribution available to Austin Energy customers and Austin residents.",
      dataSource: "Austin Energy Electric Utility Service Area, 2025, City of Austin.",
    },
  ],
}
